import { Box, Button, Loader, Tooltip } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { ElementStatus } from '@wix/rules-panel-ui';
import { SparklesSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { BiCtaNames } from '../../../../../../../bi/types';
import { useBiLogger } from '../../../../../../../hooks/use-bi-logger';
import { getDisabledButtonTooltipTranslationKeySuffix } from '../../../../utils/get-disabled-button-tooltip-translation-key-suffix';
import { useAltTextScreenContext } from '../../alt-text-screen-wrapper';
export const GenerateWithAiButton = _ref => {
  let {
    totalAmount,
    missingAmount
  } = _ref;
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    actions: {
      handleGenerateWithAiClick
    },
    state: {
      altRulesProps,
      altTextDraftDataMap,
      isGeneratingAltTextSuggestions
    }
  } = useAltTextScreenContext();
  const elementsWithMissingAlt = altRulesProps == null ? void 0 : altRulesProps.filter(_ref2 => {
    let {
      id,
      status
    } = _ref2;
    const draftData = altTextDraftDataMap == null ? void 0 : altTextDraftDataMap.get(id);
    return draftData ? draftData.status === ElementStatus.Failed : status === ElementStatus.Failed;
  });
  const disabledTooltipTranslationKeySuffix = getDisabledButtonTooltipTranslationKeySuffix(elementsWithMissingAlt, isGeneratingAltTextSuggestions);
  const elementsToGenerateAltTextFor = elementsWithMissingAlt == null ? void 0 : elementsWithMissingAlt.filter(el => el.isAiSupported);
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Tooltip, {
    content: /*#__PURE__*/React.createElement(Box, {
      align: "left",
      direction: "vertical",
      gap: "SP2",
      padding: "0 0 SP1 0"
    }, disabledTooltipTranslationKeySuffix && t(`accessibility-wizard.alt-text.generate-with-ai-button.tooltip.description.${disabledTooltipTranslationKeySuffix}`)),
    disabled: !disabledTooltipTranslationKeySuffix,
    size: "small",
    inline: true,
    onShow: () => {
      biLogger.tooltipView({
        tooltipName: disabledTooltipTranslationKeySuffix
      });
    }
  }, /*#__PURE__*/React.createElement(Box, {
    paddingTop: "3px"
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !!disabledTooltipTranslationKeySuffix || isGeneratingAltTextSuggestions,
    gap: "SP1",
    prefixIcon:
    /*#__PURE__*/
    /* temp fix until design system css bug will be fixed */
    React.createElement(Box, {
      margin: "0 4px 0 -6px"
    }, isGeneratingAltTextSuggestions ? /*#__PURE__*/React.createElement(Box, {
      paddingRight: "2px"
    }, /*#__PURE__*/React.createElement(Loader, {
      size: "tiny"
    })) : /*#__PURE__*/React.createElement(SparklesSmall, null)),
    priority: "secondary",
    size: "tiny",
    weight: "thin",
    ellipsis: true,
    onClick: () => {
      biLogger.taskCtaClick({
        ctaName: BiCtaNames.Generate,
        elementCount: totalAmount,
        failedElementCount: missingAmount
      });
      handleGenerateWithAiClick(elementsToGenerateAltTextFor);
    }
  }, `${t('accessibility-wizard.alt-text.generate-with-ai-button.cta')} (${missingAmount})`))));
};
export default GenerateWithAiButton;
//# sourceMappingURL=generate-with-ai-button.js.map